module.exports = "/assets/smile@2x.png?Tgh+a9X";